import { createContext, FC, memo, ReactNode, useContext } from 'react';

import { DynamicViewport } from '../hooks/use-dynamic-viewport';

const CoreViewerContext = createContext<DynamicViewport | undefined>(undefined);

const CoreViewerProviderInternal: FC<{ value: DynamicViewport; children: ReactNode }> = ({ value, children }) => {
	return <CoreViewerContext.Provider value={value}>{children}</CoreViewerContext.Provider>;
};

export const CoreViewerProvider = memo(CoreViewerProviderInternal);

// eslint-disable-next-line react-refresh/only-export-components
export const useCoreViewerContext = (): DynamicViewport => {
	const context = useContext(CoreViewerContext);
	if (context === undefined) {
		throw new Error('useCoreViewerContext must be used within a CoreViewerProvider');
	}
	return context;
};
